/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { AGENCY_URLS } from '@/api/url';
import { Agency } from '@/types/Agency';
import { AgencyCustomFeature } from '@/types/AgencyCustomFeature';
import { isAxiosError } from 'axios';

export interface UpdateAgencyProfilePayload {
  name: string;
}

export const apiUpdateAgencyProfile = async ({
  payload
}: {
  payload: UpdateAgencyProfilePayload;
}): Promise<ApiResponse<void>> => {
  try {
    const response = await api.put<ApiResponse<void>>(AGENCY_URLS.UPDATE_PROFILE, payload);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface UploadAgencyLogoPayload {
  file: File;
}

export const apiUploadAgencyLogo = async ({
  payload
}: {
  payload: UploadAgencyLogoPayload;
}): Promise<ApiResponse<Agency>> => {
  try {
    const formData = new FormData();
    formData.append('image', payload.file);

    const response = await api.post<ApiResponse<Agency>>(AGENCY_URLS.UPLOAD_LOGO, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiGetAgencyCustomFeatures = async (): Promise<ApiResponse<AgencyCustomFeature[]>> => {
  try {
    const response = await api.get<ApiResponse<AgencyCustomFeature[]>>(
      AGENCY_URLS.GET_CUSTOM_FEATURES
    );
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }
    throw error;
  }
};
